import Actions from '@/data/Permissions/enums.json'
import PartyEdit from '@/views/PartyEdit.vue'

export const PARTY_EDIT_SECTIONS = [
  { action: Actions.Platform.PartyEdit.Sections.PersonalDetails.View, icon: 'person', route: 'personal-details', title: 'Personal Details' },
  { action: Actions.Platform.PartyEdit.Sections.Families.View, icon: 'groups', route: 'family', title: 'Family' },
  { action: Actions.Platform.PartyEdit.Sections.Background.View, icon: 'explore', route: 'background', title: 'Background' },
  { action: Actions.Platform.PartyEdit.Sections.History.View, icon: 'alt_route', route: 'history', title: 'History' },
  { action: Actions.Platform.PartyEdit.Sections.EligibilityAssistant.View, icon: 'mdi-account-check', route: 'eligibility-assistant', title: 'Eligibility Assistant' },
  { action: Actions.Platform.PartyEdit.Sections.AsylumAssistant.View, icon: 'assistant', route: 'asylum-assistant', title: 'Asylum Assistant' },
  { action: Actions.Platform.PartyEdit.Sections.LongTermOptions.View, icon: 'list', route: 'long-term-options', title: 'Long Term Options' },
  { icon: 'quiz', route: 'party-surveys', title: 'Party Surveys' },
]

const defaultMeta = {
  requiresAuth: true,
  tmetric: {
    enabled: true,
    resource: 'party',
  },
}

export default {
  path: '/party/:id/edit',
  name: 'partyEdit',
  meta: defaultMeta,
  component: PartyEdit,
  props: true,
  redirect: { name: 'pe-personal-details' },
  children: [
    {
      path: 'personal-details',
      name: 'pe-personal-details',
      meta: { ...defaultMeta, sectionName: 'Personal Details', title: 'Personal Details - Innovation Law Lab Platform' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEPersonalDetails.vue'),
    },
    {
      path: 'overview',
      name: 'pe-overview',
      meta: { ...defaultMeta, sectionName: 'Overview', title: 'Overview - Innovation Law Lab Platform' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEOverview.vue'),
    },
    {
      path: 'family',
      name: 'pe-family',
      meta: { ...defaultMeta, sectionName: 'Family', title: 'Family - Innovation Law Lab Platform' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEFamilies.vue'),
    },
    {
      path: 'background',
      name: 'pe-background',
      meta: { ...defaultMeta, sectionName: 'Background', title: 'Background - Innovation Law Lab Platform' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEBackground.vue'),
    },
    {
      path: 'history',
      name: 'pe-history',
      meta: { ...defaultMeta, sectionName: 'History', title: 'History - Innovation Law Lab Platform' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEHistory.vue'),
    },
    {
      path: 'eligibility-assistant',
      name: 'pe-eligibility-assistant',
      meta: { ...defaultMeta, sectionName: 'Eligibility Assistant', title: 'Eligibility Assistant - Innovation Law Lab Platform' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEElligibilityAssistant.vue'),
    },
    {
      path: 'asylum-assistant',
      name: 'pe-asylum-assistant',
      meta: { ...defaultMeta, sectionName: 'Asylum Assistant', title: 'Asylum Assistant - Innovation Law Lab Platform' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PEAsylumAssistant.vue'),
    },
    {
      path: 'long-term-options',
      name: 'pe-long-term-options',
      meta: { ...defaultMeta, sectionName: 'Long Term Options', title: 'Long Term Options - Innovation Law Lab Platform' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PELongTermOptions.vue'),
    },
    {
      path: 'party-surveys',
      name: 'pe-party-surveys',
      meta: { ...defaultMeta, sectionName: 'Party Surveys', title: 'Party Surveys - Innovation Law Lab Platform' },
      props: true,
      component: _ => import('@/components/Party/PartyEdit/PESurveys.vue'),
    },
  ],
}
